import { __extends, __rest, __assign } from 'tslib';
import * as React from 'react';
import { UitkFigure } from './uitk-figure.esm.js';
import { UitkImage } from './uitk-image.esm.js';
import { queue } from './utils/image-queue.esm.js';
var UitkQueuedImage = /** @class */function (_super) {
  __extends(UitkQueuedImage, _super);
  function UitkQueuedImage(props) {
    var _this = _super.call(this, props) || this;
    _this.state = {
      src: undefined
    };
    _this.setImgRef = _this.setImgRef.bind(_this);
    return _this;
  }
  UitkQueuedImage.prototype.UNSAFE_componentWillMount = function () {
    var _a = this.props,
      serverRender = _a.serverRender,
      src = _a.src;
    if (serverRender && src) {
      this.setState({
        src: src
      });
    }
  };
  UitkQueuedImage.prototype.componentDidMount = function () {
    var state = this.state;
    var props = this.props;
    var srcFromState = state.src;
    var srcFromProps = props.src;
    if (!srcFromState) {
      this.loadImage(srcFromProps);
    }
  };
  UitkQueuedImage.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
    var src = this.props.src;
    if (src !== nextProps.src) {
      this.loadImage(nextProps.src);
    }
  };
  UitkQueuedImage.prototype.componentDidUpdate = function (prevProps) {
    var src = this.props.src;
    if (src !== prevProps.src) {
      this.loadImage(src);
    }
  };
  UitkQueuedImage.prototype.componentWillUnmount = function () {
    var _a = this.props,
      src = _a.src,
      groupId = _a.groupId;
    queue.dequeue(src, groupId);
  };
  UitkQueuedImage.prototype.setImgRef = function (r) {
    this.imgRef = r;
  };
  UitkQueuedImage.prototype.loadImage = function (src) {
    var _this = this;
    var groupId = this.props.groupId;
    if (src && src.length > 0) {
      queue.enqueue({
        callback: function (err) {
          return _this.imageDidLoad(err);
        },
        imageUrl: src,
        imgRef: this.imgRef,
        source: groupId
      });
    }
  };
  UitkQueuedImage.prototype.imageDidLoad = function (error) {
    var _a = this.props,
      queuedImageFallbackCallback = _a.queuedImageFallbackCallback,
      src = _a.src;
    if (error && queuedImageFallbackCallback) {
      queuedImageFallbackCallback(this);
    } else {
      this.setState({
        src: src
      });
    }
  };
  UitkQueuedImage.prototype.render = function () {
    var _a = this.props,
      alt = _a.alt,
      children = _a.children,
      className = _a.className,
      useBackgroundImage = _a.useBackgroundImage,
      ratio = _a.ratio;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.src; // This is destructured so it's not passed down as additionalProps
    var serverRender = _a.serverRender,
      serverRenderCallback = _a.serverRenderCallback,
      loaded = _a.loaded,
      restOfProps = __rest(_a, ["alt", "children", "className", "useBackgroundImage", "ratio", "src", "serverRender", "serverRenderCallback", "loaded"]);
    var src = this.state.src;
    var additionalProps = __assign({
      alt: alt,
      'data-loaded': Boolean(src)
    }, restOfProps);
    if (additionalProps.groupId) {
      delete additionalProps.groupId;
    }
    if (useBackgroundImage) {
      var style = src ? {
        backgroundImage: "url(".concat(src, ")")
      } : {};
      if (serverRender && serverRenderCallback) {
        style = serverRenderCallback(style);
      }
      return React.createElement(UitkFigure, {
        className: className,
        style: style,
        ratio: ratio,
        additionalProps: additionalProps
      }, children, !src && loaded && React.createElement(UitkImage, {
        placeholderImage: true
      }));
    }
    return React.createElement(UitkImage, {
      imgRef: this.setImgRef,
      className: className,
      src: src,
      alt: alt,
      additionalProps: additionalProps,
      placeholderImage: !src
    });
  };
  UitkQueuedImage.displayName = 'UitkQueuedImage';
  UitkQueuedImage.defaultProps = {
    useBackgroundImage: false
  };
  return UitkQueuedImage;
}(React.Component);
export { UitkQueuedImage };